<template>
    <v-card :class="{'pa-3': $vuetify.breakpoint.smAndDown, 'py-5 px-4': $vuetify.breakpoint.mdAndUp}" :style="$vuetify.breakpoint.lgAndUp ? 'width:1128px' : ''">
        <v-icon class="modal-close" @click.native="CLOSE_MODAL('course_stat_modal')">close</v-icon>
        <v-card-title class="display-1 mb-4">{{ course_info_stats.course_name }}</v-card-title>
        <v-layout wrap justify-space-between align-content-space-between
                  :class="{'mb-4': $vuetify.breakpoint.xs}"
        >
            <v-flex md5 sm8 xs12>
                <v-layout align-center>
                    <v-flex>
                        <labelTopic v-if="course_info_stats.required_course" class="section-label--red">{{$t("Обязательный курс")}}</labelTopic>
                    </v-flex>
                    <v-layout class="grey-text ml-3">
                        <svg v-svg
                             symbol="series"
                             class="study__icon study__icon-grey"
                             role="presentation"
                        />
                        <v-flex>
                            <span>{{ course_info_stats.course_series_name }}</span>
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-space-between :class="{'background-light body-2 mt-2': $vuetify.breakpoint.xs, 'mt-4': $vuetify.breakpoint.smAndUp}">
            <v-flex class="background-light pa-3" :class="{'mr-3': $vuetify.breakpoint.smAndUp}">
                <div>{{ $t("Все курсы") }}</div>
                <div class="red-text pt-2" :class="{'title': $vuetify.breakpoint.xs, 'display-1': $vuetify.breakpoint.smAndUp}">{{ course_info_stats.all_course_count }}</div>
            </v-flex>
            <v-flex class="background-light pa-3" :class="{'mr-3': $vuetify.breakpoint.smAndUp}">
                <v-layout row align-center>
                    <v-flex justify-end :class="{'pr-3': $vuetify.breakpoint.smAndUp}">
                        <div class="mb-2">{{$t("Новые курсы")}}</div>
                        <div>{{ course_info_stats.new_course_count }}
                            <!-- <span v-if="$vuetify.breakpoint.xs" class="green-text ml-2">32%</span> -->
                        </div>
                    </v-flex>
                    <v-flex v-if="$vuetify.breakpoint.smAndUp" md3 lg3
                            xs4 mr-2
                    >
                        <v-progress-circular
                            :rotate="-90"
                            size="64"
                            :width="6"
                            :value="percent(course_info_stats.all_course_count,course_info_stats.new_course_count)"
                            class="green-text"
                        >
                            {{ percent(course_info_stats.all_course_count,course_info_stats.new_course_count) }}%
                        </v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex class="background-light pa-3" :class="{'mr-3': $vuetify.breakpoint.lgAndUp}">
                <v-layout row align-center>
                    <v-flex justify-end :class="{'mr-3': $vuetify.breakpoint.smAndUp}">
                        <div class="mb-2">{{$t("Завершенные курсы")}}</div>
                        <div>{{ course_info_stats.completed_course_count }}
                            <span v-if="$vuetify.breakpoint.xs" class="grey-text ml-2">50%</span>
                        </div>
                    </v-flex>
                    <v-flex v-if="$vuetify.breakpoint.smAndUp" md3 lg3
                            xs4 mr-2
                    >
                        <v-progress-circular
                            :rotate="-90"
                            size="64"
                            :width="6"
                            :value="percent(course_info_stats.all_course_count,course_info_stats.completed_course_count)"
                            class="grey-text"
                        >
                            {{ percent(course_info_stats.all_course_count,course_info_stats.completed_course_count) }}%
                        </v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex class="background-light pa-3 xl5 xs12" :class="{'mt-4': $vuetify.breakpoint.lgAndDown}">
                <v-layout row align-center>
                    <v-flex justify-end class="mr-3" md2>
                        <div class="mb-2">{{$t("Идет обучение")}}</div>
                        <div>{{ course_info_stats.in_progress }}
                            <span v-if="$vuetify.breakpoint.xs" class="red-text ml-2">13%</span>
                        </div>
                    </v-flex>
                    <v-flex v-if="$vuetify.breakpoint.smAndUp" md3 lg3
                            xs4 mr-2
                    >
                        <v-progress-circular
                            :rotate="-90"
                            size="64"
                            :width="6"
                            :value="percent(course_info_stats.all_course_count,course_info_stats.current_course_count)"
                            class="red-text"
                        >
                            {{ percent(course_info_stats.all_course_count,course_info_stats.current_course_count) }}%
                        </v-progress-circular>
                    </v-flex>
                    <v-flex justify-end class="mr-3">
                        <div class="mb-2">{{$t("Не просрочен")}}</div>
                        <div><span class="green-text mr-2">{{ course_info_stats.not_expired_course_history_count }}</span><span class="grey-text">({{ percent(course_info_stats.current_course_count,course_info_stats.not_expired_course_history_count) }}%)</span></div>
                    </v-flex>
                    <v-flex justify-end class="mr-3">
                        <div class="mb-2">{{$t("Просрочен")}}</div>
                        <div><span class="red-text mr-2">{{ course_info_stats.expired_course_history_count }}</span><span class="grey-text">({{ percent(course_info_stats.current_course_count,course_info_stats.expired_course_history_count) }}%)</span></div>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout class="my-5 wrap justify-space-between">
            <v-flex md6 xs12 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}">
                <v-layout wrap>
                    <v-flex class="xs12 mb-3" :class="{'title': $vuetify.breakpoint.smAndDown, 'headline': $vuetify.breakpoint.mdAndUp}">{{ $t("Курс") }}</v-flex>
                    <v-flex class="md4 sm6 xs6 text-xs-center">
                        <div class="background-dark borders pa-2 white--text">{{$t("Дата публикации")}}</div>
                        <div class="borders pa-2">{{ course_info_stats.statement_date }}</div>
                    </v-flex>
                    <v-flex class="md4 sm6 xs6 text-xs-center">
                        <div class="background-dark borders pa-2 white--text">{{$t("Уроков в курсе")}}</div>
                        <div class="borders pa-2">{{ course_info_stats.all_lesson_count }}</div>
                    </v-flex>
                    <v-flex class="md4 sm6 xs6 text-xs-center">
                        <div class="background-dark borders pa-2 white--text">{{$t('Уроки "Продажи"')}}</div>
                        <div class="borders pa-2">{{ course_info_stats.all_lesson_sales_count }}</div>
                    </v-flex>
                    <v-flex class="md4 sm6 xs6 text-xs-center">
                        <div class="background-dark borders pa-2 white--text">{{$t("Вопросы в тесте")}}</div>
                        <div class="borders pa-2">{{ course_info_stats.question_count }}</div>
                    </v-flex>
                    <v-flex class="md4 sm6 xs6 text-xs-center">
                        <div class="background-dark borders pa-2 white--text">{{$t("Вопросы “Продажи”")}}</div>
                        <div class="borders pa-2">{{ course_info_stats.question_sales_count }}</div>
                    </v-flex>
                    <v-flex class="md4 sm6 xs6 text-xs-center">
                        <div class="background-dark borders pa-2 white--text">{{$t("Порог прохождения")}}</div>
                        <div class="borders pa-2">{{ percent(course_info_stats.points_max, course_info_stats.points_min) }}% ({{ course_info_stats.points_min }} {{$t("из")}} {{ course_info_stats.points_max }})</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex md6 xs12>
                <v-flex class="xs12 mb-3" :class="{'title mt-4': $vuetify.breakpoint.smAndDown, 'headline': $vuetify.breakpoint.mdAndUp}">{{$t("Итоговый тест")}}</v-flex>
                <v-layout>
                    <v-flex class="text-xs-center">
                        <div class="background-dark borders pa-2 white--text">{{$t("Выше порога")}}</div>
                        <div class="borders pa-2">{{ course_info_stats.test_above }}</div>
                    </v-flex>
                    <v-flex class="text-xs-center">
                        <div class="background-dark borders pa-2 white--text">{{$t("Ниже порога")}}</div>
                        <div class="borders pa-2">{{ course_info_stats.test_below }}</div>
                    </v-flex>
                    <v-flex class="text-xs-center">
                        <div class="background-dark borders pa-2 white--text">{{$t("Средний балл")}}</div>
                        <div class="borders pa-2">{{ course_info_stats.test_average_points }}</div>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-space-between align-center>
            <v-flex lg6 md6 sm12
                    xs12 class="mb-4"
            >
                <v-layout>
                    <!-- <v-layout align-center>
                        <div class="graph-green-line mr-3"></div>
                        <v-flex>{{$t("Порог баллов")}}</v-flex>
                    </v-layout> -->
                    <!-- <v-layout align-center>
                        <div class="graph-blue-line mr-3"></div>
                        <v-flex>{{$t('Порог баллов без блока "Продажи"')}}</v-flex>
                    </v-layout> -->
                </v-layout>
            </v-flex>
            <v-flex lg5 md6 sm12
                    xs12 class="mb-4"
            >
                <div class="text-uppercase mb-3">{{$t("Дата/Период")}}</div>
                <v-layout row wrap justify-space-between>
                    <datepicker :class="{'mb-3': $vuetify.breakpoint.xs, 'mr-3': $vuetify.breakpoint.sm }" class="flex md6 sm5 xs12" placeholder="01-01-2018"
                                @change="get_period_start($event)"
                    />
                    <datepicker class="flex xs12 sm5 md6" placeholder="01-01-2018" @change="get_period_finish($event)" />
                </v-layout>
            </v-flex>
        </v-layout>
        <div class="wrapper-relative">
            <div id="js-legend" class="chart-legend grey-text"></div>
            <canvas id="myChart" width="400" height="150"
                    class="pl-4"
            ></canvas>
        </div>
    </v-card>
</template>

<script>
import labelTopic from '@/components/ui/labels/label_topic.vue';
import datepicker from '@/components/ui/inputs/base/datepicker.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import Chart from 'chart.js';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';

dayjs.extend(utc);
export default {
  components: {
    labelTopic,
    datepicker,
  },
  data() {
    return {
      pagination: {
        sortBy     : 'name',
        rowsPerPage: 10,
      },
      datacollection: null,
      periods       : {
        period_start : 0,
        period_finish: 0,
      },
      chart: {},
    };
  },
  computed: {
    ...mapGetters('employee_study', [
      'current_course',
    ]),
    ...mapGetters('employee_study/modal', [
      'status_changes',
      'test_attemps',
      'course_info_stats',
      'chart_labels',
      'chart_data',
      'threshold_value',
    ]),
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  async mounted() {
    await this.get_course_detail(this.periods);
    this.chartCreate(false);
    this.periods.period_start = this.chart_labels[0];
    this.periods.period_finish = this.chart_labels[this.chart_labels.length-1];
  },
  methods: {
    percent(total, value) {
      if (value<total) {
        return Math.round((value/total)*100);
      } else return 100;
    },
    get_date(date) {
      return new dayjs(parseInt(date)).utc().format('DD.MM.YYYY');
    },
    ...mapMutations('employee_study', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapActions('contact/requests', [
      'ask_question',
    ]),
    ...mapActions('employee_study/modal', [
      'get_course_detail',
    ]),
    async get_period_start(event) {
      this.periods.period_start = event.target.value.split(' ')[0];
      await this.get_course_detail(this.periods);
      // this.chart.data.datasets.shift();
      let points = {
        label          : 'Средний балл',
        backgroundColor: 'transparent',
        borderColor    : '#e2173d',
        data           : this.chart_data,
        spanGaps       : true,
      };
      this.chart.data.datasets[0]=points;
      this.chart.update();
      // this.chartCreate(true);
    },
    async get_period_finish(event) {
      this.periods.period_finish = event.target.value.split(' ')[0];
      await this.get_course_detail(this.periods);
      let points = {
        label          : 'Средний балл',
        backgroundColor: 'transparent',
        borderColor    : '#e2173d',
        data           : this.chart_data,
        spanGaps       : true,
      };
      this.chart.data.datasets[0]=points;
      this.chart.update();
      // this.chartCreate(true);
    },
    chartCreate(update) {
      let ctx = document.getElementById('myChart');
      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels  : this.chart_labels,
          datasets: [
            {
              label          : 'Средний балл',
              backgroundColor: 'transparent',
              borderColor    : '#e2173d',
              data           : this.chart_data,
              spanGaps       : true,
            },
            // {
            //   radius         : 0,
            //   borderWidth    : 1,
            //   label          : 'Порог баллов',
            //   backgroundColor: 'transparent',
            //   borderColor    : '#44b69e',
            //   data           : this.threshold_value,
            // },
            // {
            //   radius         : 0,
            //   borderWidth    : 1,
            //   label          : 'Порог баллов без блока "Продажи"',
            //   backgroundColor: 'transparent',
            //   borderColor    : '#2755cf',
            //   data           : this.threshold_value,
            // },
          ],
        },
        options: {
          scales: {
            xAxes: [{
              offset   : false,
              gridLines: {
                display: false,
              },
            }],
            yAxes: [{
              ticks: {
                suggestedMin: 0,
                suggestedMax: this.course_info_stats.points_max,
              },
            }],
          },
          legendCallback: function(chart) {
            return '<div class=\'chart-legend\'>{{"Средний балл"}}</div>';
          },
          legend: {
            display  : false,
            fullWidth: false,
            position : 'left',
            labels   : {
              boxWidth : 0,
              fontColor: '#9b9b9b',
              fontSize : 15,
              filter(item, data) {
                if (item.text=='Средний балл') {
                  return item;
                }
              },
            },
          },
          tooltips: {
            enabled: false,
            custom : function(tooltipModel) {
              let tooltipEl = document.getElementById('chartjs-tooltip');

              // Create element on first render
              if (!tooltipEl) {
                tooltipEl = document.createElement('div');
                tooltipEl.id = 'chartjs-tooltip';
                tooltipEl.innerHTML = '<div class="layout column pa-1 tooltip-wrap"></div>';
                document.body.appendChild(tooltipEl);
              }
              // Hide if no tooltip
              if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = 0;
                return;
              }

              // Set caret Position
              tooltipEl.classList.remove('above', 'below', 'no-transform');
              if (tooltipModel.yAlign) {
                tooltipEl.classList.add(tooltipModel.yAlign);
              } else {
                tooltipEl.classList.add('no-transform');
              }

              function getBody(bodyItem) {
                return bodyItem.lines;
              }
              let innerHtml = '';
              // Set Text
              if (tooltipModel.body) {
                let titleLines = tooltipModel.title || [];
                let bodyLines = tooltipModel.body.map(getBody);
                titleLines.forEach(function(title) {
                  innerHtml += '<v-flex class="font-weight-bold">' + title + '</v-flex>';
                });

                bodyLines.forEach(function(body, i) {
                  let colors = tooltipModel.labelColors[i];
                  let style = 'background:' + colors.backgroundColor;
                  style += '; border-color:' + colors.borderColor;
                  style += '; border-width: 2px';
                  let span = '<span style="' + style + '"></span>';
                  innerHtml += '<v-flex>' + span + body + '</v-flex>';
                });

                let tableRoot = tooltipEl.querySelector('.tooltip-wrap');
                tableRoot.innerHTML = innerHtml;
              }

              // `this` will be the overall tooltip
              let position = this._chart.canvas.getBoundingClientRect();

              // Display, position, and set styles for font
              tooltipEl.classList.add('graph-tooltip');
              tooltipEl.style = 'z-index: 999';
              tooltipEl.style.position = 'absolute';
              tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
              tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
              tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
              tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
              tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
              tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
              tooltipEl.style.pointerEvents = 'none';
            },
          },
        },
      });
      // if (update) {
      //   chart.data.labels.forEach((label) => {
      //     chart.data.labels.pop();
      //   });

      //   this.chart_labels.forEach((label)=>{
      //     chart.data.labels.push(label);
      //   });
      //   chart.update();
      // }
      document.getElementById('js-legend').innerHTML = this.chart.generateLegend();
    },
  },


};
</script>

<style lang="less">
.graph-green-line {
   width: 16px;
   height: 2px;
   background-color: #44b69e;
}
.graph-blue-line {
   width: 16px;
   height: 2px;
   background-color: #2755cf;
}
.graph-tooltip {
    opacity: 0.8;
    border-radius: 4px;
    border: 1px solid #e2173d;
    background-color: #ffffff;
    z-index: 10;
}
.chart-legend {
   position: absolute;
   top: 50%;
   left: -20px;
   transform: rotate(-45deg);
   white-space: nowrap;
}
</style>
